import React, { Component } from 'react';

export default class LoadingImage extends Component {
    render() {
        if(this.props.absolute === 'true') 
            return  <img src="/images/loading.gif" alt="Carregando..." title="Carregando..." className="img-fluid" style={{maxWidth: '130px'}} { ...this.props}/>
        else
            return <div className="d-flex align-items-center justify-content-center w-100 p-4"><img src="/images/loading.gif" alt="Carregando..." title="Carregando..." className="img-fluid" style={{maxWidth: '130px'}} { ...this.props}/></div>;
    }
}